import { useLoginStore } from '@/login/stores/useLoginStore';
import { queryOptions } from '@tanstack/vue-query';
import type { QueryOptions } from '@tanstack/vue-query';
import type { Collection} from '@/newApi/services/ResgateManager';
import { ResErr, ResgateManager } from '@/newApi/services/ResgateManager';
import type { PayBand } from '@sysarb/sysarb-types-v2/services/v1/job';

type JobPayBandsOptions = {
    queries: {
        getJobPayBands: (subscribe?: boolean) => QueryOptions<Collection<PayBand> | null, Error, PayBand[]>,
    },
};

export const jobPayBands: JobPayBandsOptions = {
    queries: {
        getJobPayBands: (subscribe: boolean = true): QueryOptions<Collection<PayBand> | null, Error, PayBand[]> => {
            const { instanceTopic } = useLoginStore();
            const topic = `v1.${instanceTopic}.jobs.paybands`;
            return queryOptions<Collection<PayBand> | null, Error, PayBand[]>({
                meta: {
                    subscribe,
                    type: 'resgate',
                    resourceId: topic,
                },
                queryKey: ['paybands', topic],
                queryFn: async (): Promise<Collection<PayBand> | null> => {
                    return ResgateManager.getInstance().collection<PayBand>(topic).then(res => {
                        if (res instanceof ResErr) {
                            throw new Error(res.message);
                        }
                        return res;
                    });
                },
                select: (data) => data?.list ?? [],
            });
        },
    },
};
